import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/appActions';
import {browserHistory} from 'react-router';


class Logout extends React.Component {
  componentWillMount () {
    this.props.actions.logout();
    browserHistory.push('/login');
  }

  componentDidMount() {
      document.title = "Flagship / Logged Out";
  }

  render () {
    return null;
  }
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(Logout);




// WEBPACK FOOTER //
// ./src/components/views/Logout.js